import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Contractor.api';

export const getContractorsRequest = () => ({
  type: actionTypes.GET_CONTRACTOR_REQUEST,
});

export const getContractorsSuccess = (maternity) => ({
  type: actionTypes.GET_CONTRACTOR_SUCCESS,
  payload: maternity,
});

export const getContractorsFailure = (error) => ({
  type: actionTypes.GET_CONTRACTOR_FAILURE,
  payload: error,
});

export const getContractors = (date) => {
  return async (dispatch) => {
    dispatch(getContractorsRequest(date));
    try {
      const leaves = await api.fetchContractorsData(date);
      dispatch(getContractorsSuccess(leaves));
      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getContractorsFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateContractorsRequest = (id, maternityData) => ({
  type: actionTypes.UPDATE_CONTRACTOR_REQUEST,
  payload: { id, maternityData },
});

export const updateContractorsSuccess = (message) => ({
  type: actionTypes.UPDATE_CONTRACTOR_SUCCESS,
  payload: message,
});

export const updateContractorsFailure = (error) => ({
  type: actionTypes.UPDATE_CONTRACTOR_FAILURE,
  payload: error,
});

export const updateContractorsById = (id, contractorData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    contractorData.updated_by = user.user_name;

    dispatch(updateContractorsRequest(id, contractorData));
    try {
      const response = await api.updateContractors(id, contractorData);
      dispatch(updateContractorsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateContractorsFailure(error));
      return { success: false, message: error };
    }
  };
};



export const deleteContractorsRequest = (id) => ({
  type: actionTypes.DELETE_CONTRACTOR_REQUEST,
  payload: id,
});

export const deleteContractorsSuccess = (message) => ({
  type: actionTypes.DELETE_CONTRACTOR_SUCCESS,
  payload: message,
});

export const deleteaternityBenefitsFailure = (error) => ({
  type: actionTypes.DELETE_CONTRACTOR_FAILURE,
  payload: error,
});

export const deleteContractorsById = (id) => {
  return async (dispatch) => {
    dispatch(deleteContractorsRequest(id));
    try {
      const response = await api.deleteContractors(id);
      dispatch(deleteContractorsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};



export const uploadContractorsRequest = (fileData) => ({
  type: actionTypes.UPLOAD_CONTRACTOR_REQUEST,
  payload: fileData,
});

export const uploadContractorsSuccess = (message) => ({
  type: actionTypes.UPLOAD_CONTRACTOR_SUCCESS,
  payload: message,
});

export const uploadContractorsFailure = (error) => ({
  type: actionTypes.UPLOAD_CONTRACTOR_FAILURE,
  payload: error,
});

export const uploadContractorsFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadContractorsRequest(fileData));
    try {
      const response = await api.ContractorsUpload(fileData);
      dispatch(uploadContractorsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadContractorsFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteContractorsRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_CONTRACTOR_REQUEST,
  payload: ids,
});

export const multiDaleteContractorsSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_CONTRACTOR_SUCCESS,
  payload: message,
});

export const multiDaleteContractorsFailure = (error) => ({
  type: actionTypes.MULTIDELETE_CONTRACTOR_FAILURE,
  payload: error,
});

export const multiDeleteContractors = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteContractorsRequest(ids));
    try {
      const response = await api.multiDeleteContractors(ids);
      dispatch(multiDaleteContractorsSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteContractorsFailure(error));
      return { success: false, message: error };
    }
  };
};


